import { useNavigate } from 'react-router-dom';
import styles from './Card.module.scss';

interface IPropsCard {
    title: string;
    description: string;
    sucess: string;
}

const Card = ({ title, description, sucess }: IPropsCard) => {
    const navigate = useNavigate();

    const handleNavigate = () => {
        void navigate(`/sucessos/?caso=${sucess}`);
    };

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <h2 className={styles.titulo}>{title}</h2>
                <p>{description}</p>
                <span onClick={handleNavigate}>Saiba Mais</span>
            </div>
        </div>
    );
};

export default Card;
